import { Currency } from '@/core/currency/interfaces';

const ARS: Currency = {
    name: 'Argentine Peso',
    demonym: 'Argentine',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '032',
    symbol: 'AR$',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ARS',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ARS;
